module.exports = __webpack_public_path__ + "static/media/shmooze.de32e844.png";